<template>
  <div>
    <!-- one recap -->
    <b-modal id="clueRecapsModalSingle" hide-footer centered no-fade>
      <template slot="modal-header">
        <b-button class="close" aria-label="fermer" @click="hideModal('clueRecapsModalSingle')">X</b-button>
      </template>

      <div class="no-border">
        <br aria-hidden="true" />
        <div class="row">
          <div class="col-sm-4">
            <br aria-hidden="true" />
            <img :src="getImage(recaps[currentTab].recapImage)" class="img-fluid centered-element recap-image" :alt="LG(recaps[currentTab].recapAlt)" />
          </div>
          <div class="col">
            <br aria-hidden="true" />
            <h2>{{ LG("CR_recapHeading") }}</h2>
            <p v-html="LG(getParagraph(currentTab))" v-if="!hasParagraphPopover(currentTab)"></p>
            <p v-if="hasParagraphPopover(currentTab)">
              <PopupLinker :paragraph="LG(getParagraph(currentTab))" :content="getParagraphPopover(currentTab)"></PopupLinker>
            </p>
            <ul v-for="bullet in recaps[currentTab].recapBullets" :key="bullet.text">
              <li v-html="LG(bullet.text)" v-if="!hasBulletPopover(bullet)"></li>
              <li v-if="hasBulletPopover(bullet)">
                <PopupLinker :paragraph="LG(bullet.text)" :content="LG(bullet.popover)" :content2="LG(bullet.popover2)"></PopupLinker>
              </li>
            </ul>
            <div v-if="hasParagraph2(currentTab)">
              <p v-html="LG(getParagraph2(currentTab))"></p>
              <ul v-for="bullet in recaps[currentTab].recap2Bullets" :key="bullet.text">
                <li v-html="LG(bullet.text)" v-if="!hasBulletPopover(bullet)"></li>
                <li v-if="hasBulletPopover(bullet)">
                  <PopupLinker :paragraph="LG(bullet.text)" :content="LG(bullet.popover)"></PopupLinker>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12">
            <div class="bloc-note-link-wrapper h2">
              Écris tes observations dans le bloc-notes.
              <BlocNoteAndBtn modalId="singleModal" :situationIndex="situationIndex" :noteId="recaps[currentTab].clueId" class="recaps-bloc-note-btn" />
            </div>
          </div>
        </div>

        <br aria-hidden="true" />
        <br aria-hidden="true" />
        <div class="centered-element" v-if="showContinueButton()">
          <b-button class="funky-shape" v-on:click="onContinueButtonClicked()">{{ getSubmitButtonLabel() }}</b-button>
        </div>
      </div>
    </b-modal>

    <!--recap tab -->
    <b-modal id="clueRecapsModalTab" hide-footer centered no-fade>
      <template slot="modal-header">
        <b-button class="close" aria-label="fermer" @click="hideModal('clueRecapsModalTab')">X</b-button>
      </template>
      <b-tabs nav-wrapper-class="clue-tabs">
        <b-tab @click="onTabClicked(recap.clueId)" title="Indice" :active="recaps[currentTab].clueId == recap.clueId" v-for="(recap, index) in recapsFiltered" :key="recap.clueId" :aria-label="'onglet indice ' + index" title-link-class="clue-tab-new">
          <!-- clue-tab-selected-new -->
          <div class="row">
            <div class="col-sm-4">
              <br aria-hidden="true" />
              <img :src="getImage(recap.recapImage)" class="img-fluid centered-element recap-image" :alt="LG(recap.recapAlt)" />
            </div>
            <div class="col">
              <br aria-hidden="true" />
              <h2>{{ LG("CR_recapHeading") }}</h2>
              <p v-html="LG(recap.recapText)" v-if="!recap.paragraphPopover != null"></p>
              <p v-if="recap.paragraphPopover != null">
                <PopupLinker :paragraph="LG(recap.recapText)" :content="LG(recap.paragraphPopover)"></PopupLinker>
              </p>
              <ul>
                <li v-for="bullet in recap.recapBullets" :key="bullet.text" class="mb-3">
                  <span v-html="LG(bullet.text)" v-if="!hasBulletPopover(bullet)"></span>

                  <PopupLinker v-if="hasBulletPopover(bullet)" :paragraph="LG(bullet.text)" :content="LG(bullet.popover)" :content2="LG(bullet.popover2)"></PopupLinker>
                </li>
              </ul>
              <div v-if="recap.recap2Text != null">
                <p v-html="LG(recap.recap2Text)"></p>
                <ul>
                  <li v-for="bullet in recap.recap2Bullets" :key="bullet.text" class="mb-3">
                    <span v-html="LG(bullet.text)" v-if="!hasBulletPopover(bullet)"></span>
                    <PopupLinker v-if="hasBulletPopover(bullet)" :paragraph="LG(bullet.text)" :content="LG(bullet.popover)"></PopupLinker>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12">
              <div class="bloc-note-link-wrapper h2">
                Écris tes observations dans le bloc-notes.
                <BlocNoteAndBtn :modalId="'blocNoteModal' + index" :situationIndex="situationIndex" :noteId="recap.clueId" class="recaps-bloc-note-btn" />
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>

      <div class="centered-element" v-if="showContinueButton()">
        <b-button class="funky-shape" v-on:click="onContinueButtonClicked()">{{ getSubmitButtonLabel() }}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PopupLinker from "@/components/PopupLinker.vue";
import BlocNoteAndBtn from "@/components/BlocNoteAndBtn.vue";

export default {
  name: "ClueRecaps",
  components: {
    PopupLinker,
    BlocNoteAndBtn,
  },
  props: {
    id: {
      type: String,
      default: "id-clue-recaps",
    },
    recaps: {
      type: Array,
    },
    situationIndex: {
      type: Number,
    },
  },
  data() {
    return {
      // Array

      // Images

      // Variables
      blocNoteVisible: false,
      showingPedagogyPage: false,
      currentTab: 0,
      searchMode: false,
    };
  },

  computed: {
    recapsFiltered() {
      return this.recaps.filter((x) => x.unlocked == true);
    },
    showTabs() {
      return this.searchMode;
    },
  },
  methods: {
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showBlocNote() {
      this.blocNoteVisible = true;
    },
    hideBlocNote() {
      this.blocNoteVisible = false;
    },
    showNextButton() {
      if (this.newVersion()) {
        return false; // In new version, we only show the pedagogy info in the summary page!
      }
      return !this.showingPedagogyPage;
    },
    showContinueButton() {
      if (!this.newVersion()) {
        return false;
      }
      return !this.showingPedagogyPage;
    },
    getSubmitButtonLabel() {
      // In search mode we are just browsing, not submitting (saving)
      if (this.searchMode) {
        return this.LG("G_continueLabel");
      } else {
        return this.LG("G_submitButtonLabel");
      }
    },
    getPopupCloseContainerClass() {
      // In new version, there is a search mode which has a lower close button
      if (!this.searchMode) {
        return "popup-close";
      } else {
        return "popup-close bring-close-button-down";
      }
    },
    getPopupCloseButtonClass() {
      return "popup-close-button";
    },

    getGreenBorderCss() {
      if (this.newVersion()) {
        if (this.searchMode) {
          return "blue-border border-top-left-square";
        } else {
          return "no-border";
        }
      }
      // When in tab mode we square off the top left corner of the green square
      return "green-border border-top-left-square";
    },
    getImage(image) {
      return require("../assets/" + image);
    },
    getParagraph(index) {
      return this.recaps[index].recapText;
    },
    hasParagraphPopover(index) {
      return this.recaps[index].paragraphPopover != null;
    },
    getParagraphPopover(index) {
      return this.LG(this.recaps[index].paragraphPopover);
    },
    hasParagraph2(index) {
      return this.recaps[index].recap2Text != null;
    },
    getParagraph2(index) {
      return this.recaps[index].recap2Text;
    },
    hasPedagogyPopover(index) {
      if (this.recaps[index].popover != null) {
        return true;
      }
      return false;
    },
    hasBulletPopover(bullet) {
      if (bullet.popover != null) {
        return true;
      }
      return false;
    },
    getPedagogy(index) {
      return this.recaps[index].recapPedagogy;
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    onNextButtonClicked() {
      this.showingPedagogyPage = true;
      this.$emit("next-clicked");
    },
    onPrevButtonClicked() {
      this.showingPedagogyPage = false;
      this.$emit("prev-clicked");
    },
    onContinueButtonClicked() {
      this.hideModal("clueRecapsModalTab");
      this.hideModal("clueRecapsModalSingle");
      this.$emit("ok-clicked");
    },
    onPopupCloseButtonClicked() {
      this.hideModal("clueRecapsModalTab");
      this.hideModal("clueRecapsModalSingle");
      this.$emit("close-clicked");
    },
    onTabClicked(index) {
      this.$emit("tab-clicked", index - 1);
    },
    getTabLabel(index) {
      if (this.newVersion()) {
        // In new version, unlock order (left to right 1..)
        //var unlockOrder = this.getUnlockOrder(index);
        return this.LG("CR_tabLabel"); // + unlockOrder;
      }

      var clueNumber = Number(index) + 1;
      return this.LG("CR_tabLabel") + clueNumber;
    },
    getUnlockOrder(index) {
      var order = 0;
      var num = Number(index);
      for (var i = 0; i < this.recaps.length; i++) {
        if (this.recaps[i].unlocked) {
          order++;
        }
        if (num == i) {
          return order;
        }
      }
      return order;
    },
    getTabClass(index) {
      if (this.currentTab == Number(index)) {
        if (this.newVersion()) {
          return "clue-tab clue-tab-new clue-tab-selected clue-tab-selected-new";
        } else {
          return "clue-tab clue-tab-selected";
        }
      } else {
        if (this.recaps[Number(index)].unlocked) {
          if (this.newVersion()) {
            return "clue-tab clue-tab-new";
          } else {
            return "clue-tab";
          }
        } else {
          return "clue-tab clue-tab-disabled";
        }
      }
    },
    showThisTab(index) {
      // In the new version we never show the disabled tabs at all!
      if (this.newVersion()) {
        if (this.isButtonDisabled(index)) {
          return false;
        }
      }
      return true;
    },
    isButtonDisabled(index) {
      if (this.recaps[index].unlocked) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.h2 {
  font-size: 18px !important;
  font-weight: bold;
}

.bloc-note-link-wrapper {
  position: relative;

  border-radius: 20px;
  border: 10px solid #ffffff;
  padding: 10px !important;
  background-color: #f3f3f3;

  max-width: 300px;

  margin-top: 30px;
  margin-left: 15px;
  padding: 20px !important;
  padding-right: 30px !important;
}

.recaps-bloc-note-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(55%, -50%);
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");
@import url("https://fonts.googleapis.com/css?family=Nunito");

.green-border {
  border: 20px solid #3f5d12;
  width: 95%;
  padding: 10px;
  border-radius: 15px 15px 15px 15px;
}

.blue-border {
  border: 20px solid white;
  width: 100%;
  padding: 10px;
  border-radius: 15px 15px 15px 15px;
  background-color: #f3f3f3;
}

.no-border {
  width: 100%;
  padding-right: 10px;
}

.border-top-left-square {
  border-radius: 0px 15px 15px 15px !important;
}
.clue-tab {
  position: relative;
  background-color: #2f450d;
  border-radius: 10px 10px 0px 0px;
  color: white;
  font-family: "Poppins";
  font-size: 17px;
  border: none;
  padding-top: 5px;
  padding-right: 13px;
  padding-left: 13px;
  bottom: 6px;
  outline: none !important;
}
.clue-tabs {
  margin-top: calc(0px - 2rem - 25px - 10px - 1rem - 47px);
  padding-bottom: 3rem;
}
.clue-tabs .nav-tabs {
  border: none;
}
a.clue-tab-new {
  margin-right: 10px;
  text-align: center;
  background-color: #3f5d12 !important;
  border-radius: 30px 30px 0px 2px !important;
  min-width: 150px;
  padding-top: 15px;
  padding-bottom: 5px;
  bottom: 22px;
  border-top: 1px dashed #6b98ac;
  border-left: 1px dashed #6b98ac;
  border-right: 1px dashed #6b98ac;
  color: #fff !important;
}
a.clue-tab-new.active {
  background-color: #f3f3f3 !important;
  text-shadow: 1px 1px white;
  color: black !important;
  border-top: 4px solid white !important;
  border-left: none !important;
  border-right: none !important;
}
.clue-tab-selected {
  background-color: #3f5d12;
  color: white;
  outline: none !important;
}

.clue-tab-disabled {
  color: #505050;
  /*background-color: #515151;     */
  background-color: #808080;
  outline: none !important;
}

@media only screen and (max-width: 890px) {
  .clue-tab {
    font-size: 9px;
    bottom: -5px;
  }

  .clue-tab-selected {
    bottom: -2px;
    padding-top: 10px;
  }

  .clue-tab-new {
    border-radius: 20px 20px 0px 2px !important;
    min-width: 75px;
    padding-top: 15px;
    padding-bottom: 5px;
    bottom: 8px;
  }

  .clue-tab-selected-new {
    padding-top: 15px;
    padding-bottom: 5px;
    bottom: 8px;
  }
}

.bg-recap-area {
  position: relative;
  background-color: white;
  color: black;
  font-family: "Poppins";
  font-size: 17px;
  max-width: 1000px;
  /*min-height: 550px;*/
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding-left: 80px;
  padding-right: 25px;
  padding-top: 5px;
  padding-bottom: 25px;
}

.bg-recap-area-new {
  border-radius: 50px;
  border: 10px solid #ffffff;
  padding: 10px !important;
  background-color: #f3f3f3;
}

.bg-recap-area-hide {
  background-color: transparent;
  border: none !important;
}

.recap-screen-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  backdrop-filter: blur(6px);
}

.resume-page {
  padding: 20px;
}

.purple-pill {
  background-color: #052433; /*#4E2B55;*/
  border-radius: 30px;
}

.bring-close-button-down {
  padding-top: 100px;
}
</style>
<style scoped>
/* Modal */
::v-deep .modal-dialog {
  max-width: 1200px;
  margin-top: 40px;
}
::v-deep .modal-header {
  border: none;

  height: 0px;
}
::v-deep .modal-header .close {
  opacity: 1;

  background-color: #3f5d12;
  border: 3px solid white;
  border-radius: 50%;
  color: white;
  width: 65px;
  height: 65px;

  font-weight: 500;
  font-size: 40px;
  padding: 2px;

  position: relative;
  top: -52px;

  z-index: 9;
}

::v-deep .modal-header .close:hover,
::v-deep .modal-header .close:focus,
::v-deep .modal-header .close:active {
  opacity: 1;
  background-color: gray;
}
::v-deep .modal-title {
  font-size: 1.7rem;
  font-weight: 600;
  margin-left: auto;
}

::v-deep .modal-content {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px;
  /* min-height: 640px; */
}

::v-deep .modal-backdrop {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
</style>
